<template>
  <b-table
    class="mb-0"
    striped
    small
    hover
    responsive
    no-sort-reset
    :items="results"
    :fields="fields"
    no-local-sorting
    :show-empty="!results.length"
    :empty-text="$gettext('no results found')"
    @sort-changed="sortChanged"
    sticky-header="80vh"
  >
    <template v-slot:cell(index)="{ index }">
      {{ pageIndex + index + 1 }}
    </template>
    <template v-slot:cell(buttons)="{ item }">
      <edit-delete-buttons
        @edit="edit(item.id)"
        @remove="remove(item.id)"
      >
        <b-btn
          variant="secondary"
          @click="viewSubdivisions(item)"
          v-b-tooltip
          :title="$gettext('view subdivisions')"
        >
          <fa-icon icon="list-alt"/>
        </b-btn>
      </edit-delete-buttons>
    </template>
  </b-table>
</template>

<script>
export default {
  props: ['results', 'fields', 'pageIndex'],
  methods: {
    viewSubdivisions(item) {
      if (item.has_subdivisions) {
        this.$router.push({ name: 'country subdivisions', query: { country_id: item.id } })
      } else {
        this.$router.push({ name: 'cities', query: { country_id: item.id } })
      }
    },
    edit(id) {
      this.$emit('edit', id)
    },
    remove(id) {
      this.$emit('remove', id)
    },
    sortChanged(ctx) {
      this.$emit('sort-changed', ctx)
    },
  },
}
</script>
